angular.module('SpidApp')

.controller('OrderController', ['BASE_PUBLIC_URL', 'SPID_CONFIG', '$scope', '$state', '$stateParams', '$rootScope', '$localStorage', '$document', '_', 'VacationService', 'Toaster', 'Order', 'OrderService', 'OrderItem', 'StockManager', 'ProductService', 'OperationalProductService', '$timeout',
function (BASE_PUBLIC_URL, SPID_CONFIG, $scope, $state, $stateParams, $rootScope, $localStorage, $document, _, VacationService, Toaster, Order, OrderService, OrderItem, StockManager, ProductService, OperationalProductService, $timeout) {

        $scope.order = $scope.cart = Order.getInstance()
        $scope.pageLoaded = true

        var orderId = +$stateParams.id
        var lot = +$stateParams.lot
        var agencyId = +$stateParams.agency

        var resetOrder = function () {
            return OrderService.getById(agencyId, orderId, lot).then(function (data) {
                $scope.order.flush();
                $scope.order.restaureFromDb(data);

                resetOrderStatus();

                ProductService.all().then(function (products) {
                    $scope.order.objects = _.map($scope.order.objects, function (orderItem) {
                        var product = _.find(products, function (product) {
                            return product.id === orderItem.id;
                        });

                        if (product) {
                            orderItem.category = product.category
                            orderItem.barcode = product.barcode
                            orderItem.price = product.price
                            $scope.order.nbProduct++;

                            createBarcode(orderItem);
                        }

                        return orderItem;
                    });

                    return OperationalProductService.all();
                }).then(function (products) {
                    $scope.order.objects = _.map($scope.order.objects, function (orderItem) {
                        var product = _.find(products, function (product) {
                            return product.id === orderItem.id;
                        });

                        if (product) {
                            orderItem.barcode = product.barcode
                            orderItem.dapocode = product.dapocode
                            $scope.order.nbProductOp++;

                            createBarcode(orderItem);
                        }

                        return orderItem;
                    });
                });
            })
        }

        var resetOrderStatus = function () {
            if (!$scope.order.aStatus) {
                return;
            }

            var aStatus = $scope.order.aStatus;
            var lastIndexStatus = aStatus.length - 1;
            $scope.orderLastStatus = aStatus[lastIndexStatus];
            $scope.orderFisrtStatus = aStatus[0];
            $scope.order.nbProduct = 0;
            $scope.order.nbProductOp = 0;
        }

        // Init controller
        if (orderId && lot && ($scope.order.order_id !== orderId || $scope.order.lot !== lot)) {
            resetOrder();
        } else if (!orderId && $scope.order.order_id && $scope.order.lot) {
            $scope.order.flush();
        } else {
            resetOrderStatus();
        }

        $scope.saleQuantityChange = function (index, sale, onBlurEvent) {
            if (onBlurEvent && sale.quantity === undefined) {
                sale.quantity = 1;
            }

            if (onBlurEvent && (sale.quantity === null || sale.quantity === undefined || sale.quantity <= 0 || sale.quantity.length === 0)) {
                $scope.order.removeOrderItem(index)
                return
            }
        }

        $scope.incrementQuantity = function (sale) {
            if ($scope.orderIsValidated) {
                return
            }

            $scope.order.incrementOrderItemQuantity(sale)
        }

        $scope.decrementQuantity = function (index, sale) {
            if ($scope.orderIsValidated) {
                return
            }

            if (sale.quantity === null || sale.quantity === undefined || sale.quantity <= 1) {
                $scope.order.removeOrderItem(index)
            } else {
                $scope.order.decrementOrderItemQuantity(sale)
            }
        }

        $scope.saveOrder = function () {
            if (!$scope.order.isValidable()) {
                return
            }

            $scope.order.setStatusCreate();

            OrderService.save($scope.order, false, {
                currency_rate: $scope.agency.currency.rate
            }).then(function (data) {
                $scope.order = data;
                Toaster.warning('La commande a été sauvegardée');
            }).finally(function () {
                focus('payment-received-input')
            });
        }

        $scope.validateOrder = function () {
            if (!$scope.order.isValidable()) {
                return
            }

            $scope.order.setValidated()
            $scope.order.setStatusTodo();

            OrderService.save($scope.order, false, {
                currency_rate: $scope.agency.currency.rate
            }).then(function () {
                Toaster.show('La commande est terminée');
                $state.go('app.orderlist');
            }).finally(function () {
                $scope.order.setUnvalidated();
                $scope.order.flush();
            });
        }

        $scope.cancelTransaction = function () {
            if ($scope.order.isEmpty()) {
                return
            }

            $scope.order.setStatusCancel();
            OrderService.save($scope.order).then(function () {
                Toaster.danger('La commande a été annulée')
                $scope.order.setUnvalidated();
                $scope.order.flush();
            });
        }

        /*
         * Valid if Qty_Get <= Qty_Send 
         * If Qty_Get < Qty_Send ==> Status=PARTIALLY_RECEIVED
         * If Qty_Get = Qty_Send ==> Status=TOTALLY_RECEIVED
         */

        $scope.validateReceive = function () {
            $scope.order.user = $scope.user.firstname + ' ' + $scope.user.lastname;
            $scope.order.setStatusReceiveTotally();

            for (var i = 0; i < $scope.order.objects.length; i++) {
                var orderItem = $scope.order.objects[i];
                if (orderItem.quantity_send != orderItem.quantity_get) {
                    $scope.order.setStatusReceivePartially();
                    break;
                }
            }

            OrderService.save($scope.order).then(function () {
                StockManager.manageInOfStock($scope.order.objects, agencyId);

            }).then(function () {
                Toaster.show('La réception de la commande a été validée');
                resetOrder();
            })
        }

        $scope.cancelReceive = function () {
            resetOrder().then(function () {
                Toaster.show('La réception de la commande a été annulée');
            });
        }

        $scope.onBlurQuantitySend = function (sale) {
            if (!sale.quantity_get) {
                sale.quantity_get = 0;
            }
        }

        $scope.incrementQuantityGet = function (sale) {
            if (sale.quantity_get === sale.quantity_send) {
                return;
            } else {
                $scope.order.incrementQuantityGet(sale)
            }
        }

        $scope.decrementQuantityGet = function (sale) {
            if (sale.quantity_get === null || sale.quantity_get === undefined || sale.quantity_get <= 0) {
                return;
            } else {
                $scope.order.decrementQuantityGet(sale)
            }
        }

        $scope.printOrder = function () {
            $scope.dateNow = moment(new Date()).format('LLL');

            $timeout(function () {
                window.print();
            }, 50);
        }

        var createBarcode = function (orderItem) {
            $timeout(function () {
                try {
                    JsBarcode('#' + 'product-barcode-' + orderItem.id, orderItem.barcode, {
                        format: SPID_CONFIG.products.barcodes.type,
                        width: 2,
                        height: 25,
                        displayValue: true
                    })

                    var elem = $document[0].getElementById('product-barcode-' + orderItem.id)
                    orderItem.dataURI = elem.src
                    orderItem.hasImage = true
                } catch (e) {
                    console.error(e, orderItem.barcode)
                    orderItem.hasImage = false
                }
            }, 250);
        }
}])